
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/national-tree-week-update",
      function () {
        return require("private-next-pages/blog/national-tree-week-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/national-tree-week-update"])
      });
    }
  